import { useEffect, useRef } from "react"
import ModalWrapper from "../modal/ModalWrapper"
import useUiuxStore from "src/store/useUiuxStore";
import { useKSK2020_R01Store } from "src/containers/mes/KSK/KSK2020_R01/Store_KSK2020_R01";
import { useKSK2080_R01Store } from "src/containers/mes/KSK/KSK2080_R01/Store_KSK2080_R01";
import { useKSK2090_R01Store } from "src/containers/mes/KSK/KSK2090_R01/Store_KSK2090_R01";
import { useKSK2030_R01Store } from "src/containers/mes/KSK/KSK2030_R01/Store_KSK2030_R01";
import useUserStore from "src/store/useUserStore";
import { useKSK2021_R01Store } from "src/containers/mes/KSK/KSK2021_R01/Store_KSK2021_R01";
import { useKSK2120_R01Store } from "src/containers/mes/KSK/KSK2120_R01/Store_KSK2120_R01";
import { useDescLanguageStore } from "src/store/useDescLanguageStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useKSK2140_R01Store } from "src/containers/mes/KSK/KSK2140_R01/Store_KSK2140_R01";
import { useKSK2101_R01Store } from "src/containers/mes/KSK/KSK2101_R01/Store_KSK2101_R01";
import { useKSK2010_R01Store } from "src/containers/mes/KSK/KSK2010_R01/Store_KSK2010_R01";
import { useKSK2130_R01Store } from "src/containers/mes/KSK/KSK2130_R01/Store_KSK2130_R01";


export const AuthactionbarLog = () => {

	const { setAuthactionbarLogModalVisible } = useUiuxStore();
	const { editKSK2020_R01 } = useKSK2020_R01Store();
	const { KSK2021_R01DetailList, editKSK2021_R01 } = useKSK2021_R01Store();
	const { KSK2080_R01List, selectedKSK2080_R01 } = useKSK2080_R01Store();
	const { KSK2010_R01List, KSK2010_R01Filter } = useKSK2010_R01Store();
	const { KSK2090_R01DetailList } = useKSK2090_R01Store();
	const { KSK2030_R01List, KSK2030_R01Filter, editKSK2030_R01 } = useKSK2030_R01Store();
	const { KSK2120_R01List, KSK2120_R01Filter } = useKSK2120_R01Store();
	const { company } = useUserStore();
	const { KSK2101_R01Filter } = useKSK2101_R01Store();
	const { descLanguageList, selectedLanguageCd } = useDescLanguageStore();
	const { languageList } = useCommonCodeStore();
	const { menuCdList } = useCommonCodeStore();
	const { KSK2140_R01List, KSK2140_R01DetailList, KSK2140_R01InspectMap, editKSK2140_R01, KSK2140_R01LotList } = useKSK2140_R01Store();
	const { userInfo } = useUserStore();
	const { workPlaceList, warehouseCdList } = useCommonCodeStore();
	const { KSK2130_R01Filter } = useKSK2130_R01Store();
	const { KSK2140_R01Filter } = useKSK2140_R01Store();
	const contentRef = useRef<HTMLDivElement>(null);

	const handleCopy = async () => {
		if (contentRef.current) {
			try {
				await navigator.clipboard.writeText(contentRef.current.innerText);
				console.log("클립보드에 복사되었습니다.");
			} catch (err) {
				console.error("복사 실패:", err);
			}
		}
	};

	return (
		<ModalWrapper size="lg" defaultWidth={1200} overlay={true}
			onOverlayClick={() => setAuthactionbarLogModalVisible(false)}
			onEscKeyDown={() => setAuthactionbarLogModalVisible(false)}>
			<div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
				<button 
					onClick={handleCopy}
					className={`px-4 py-2 bg-blue-dark hover:bg-blue-600 active:bg-blue-800 text-white rounded-md transition-colors cursor-pointer font-bold`}
				>
					복사하기
				</button>
			</div>
			<div ref={contentRef} style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
				warehouseCdList : {JSON.stringify(warehouseCdList, null, 2)} <br/><br/>
				{/* ksk2140DetailList : {JSON.stringify(KSK2140_R01DetailList.map(v => {
					return {
						itemCd: v.itemCd,
						itemNm: v.itemNm,
						inspectQty: v.inspectQty,
						lotNo: v.lotNo,
						lotQty: v.lotQty,
						acceptQty: v.acceptQty,
						packQty: v.packQty,
						checkFinish: v.checkFinish,
						isModified: v.isModified,
					}
				}), null, 2)} <br/><br/>
				ksk2140InspectList : {JSON.stringify(Array.from(KSK2140_R01InspectMap.entries()), null, 2)} <br/><br/>
				ksk2140LotList : {JSON.stringify(KSK2140_R01LotList.map(v => {
					return {
						lotNo: v.lotNo,
						lotQty: v.lotQty,
					}
				}), null, 2)} <br/><br/> */}
			</div>
		</ModalWrapper>
	)
}
